"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (transparent48) { return function (raw) {
    transparent48.virtual.send('devAuth', {
        data: {
            randomKey: raw.slice(8, -2)
        }
    });
}; });



// WEBPACK FOOTER //
// ./src/transparent48/decode/2.ts